var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-row-h-center business-license" }, [
      _c("div", { staticClass: "left" }, [
        _c("img", {
          staticStyle: { width: "120px" },
          attrs: {
            src: require("@/assets/apply/business-license.png"),
            alt: "",
          },
        }),
      ]),
      _c("div", { staticClass: "right" }, [
        _c("p", [_vm._v("1.照片方向正确，不能颠倒")]),
        _c("p", [_vm._v("2.需文字清晰，边框完整、露出国微")]),
        _c("p", [
          _vm._v("3.请上传原件或复印件的扫描件，如上传复印件，需加盖公章"),
        ]),
        _c("p", [_vm._v("4.具备相关公司资质(网络技术公司、文化传媒公司等)")]),
        _c("p", [
          _vm._v("5.属于网络表演经纪机构的MCN机构需要上传《营业性演出许可证》"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }